import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../LaunchComponent/LaunchDataDisplay.css";
import SubmissionConfirmPopup from "./submissionConfirmPopup";
const DataDisplay = ({
 mailerParent,
 mailerChild,

 categoryCertificate,
 handleReset,
 categoryName,
 programName,
 setIsDataGenerated,
 setIsBackButtonSelected,
 setIsMailGenerated,
 setIsGenerationClicked,
 setIsNavigatedToForm,
}) => {
 const [open, setOpen] = useState(false);
 const isSubmitted = useSelector((state) => state.model.isSubmitted);
 const isMailLoaded = useSelector((state) => state.mail.isMailLoaded);

 const mailData = useSelector((state) => state.mail.mailData);

 return (
  <>
   <div className="data-display-new">
    <div className="result-container">
     <div className="result-wrap">
      <div className="result-content">
       {!isMailLoaded && (
        <Box
         display="flex"
         flexDirection="column"
         alignItems="center"
         sx={{
          height: "100%",
          justifyContent: "center",
         }}
        >
         <CircularProgress />
         <Typography variant="h6" marginTop={2}>
          Generating...
         </Typography>
        </Box>
       )}
       {isMailLoaded && mailData != "" && (
        <Stack spacing={2} sx={{ padding: "0px", background: "white" }}>
         <style>
          {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
         </style>

         <div style={{ overflowY: "scroll", border: "0px !important" }}>
          <Markdown>{mailData}</Markdown>
         </div>
        </Stack>
       )}
      </div>
      <div className="result-btn-container">
       <div className="result-left">
        {isMailLoaded && (
         <Button
          variant="outlined"
          sx={{ marginRight: "10px" }}
          disabled={isSubmitted ? true : false}
          onClick={() => {
           setOpen(true);
          }}
         >
          Submit For Approval
         </Button>
        )}
       </div>
       <div className="result-right">
        <img src={process.env.PUBLIC_URL + "/Images/Dislikeicon.png"} />
        <img src={process.env.PUBLIC_URL + "/Images/Likeicon.png"} />
       </div>
      </div>
     </div>
     <div className="return-wrap">
      <p
       onClick={() => {
        setIsGenerationClicked(false);
        setIsNavigatedToForm(true);
        setIsMailGenerated(null);
       }}
      >
       {"<"} Back
      </p>
     </div>
     <SubmissionConfirmPopup
      open={open}
      setOpen={setOpen}
      mailerParent={mailerParent}
      mailerChild={mailerChild}
      modalResponse={mailData}
      categoryCertificate={categoryCertificate}
      programName={programName}
      categoryName={categoryName}
      handleReset={handleReset}
     />
    </div>
   </div>
  </>
 );
};

export default DataDisplay;
